import { compose, withState, withHandlers } from 'recompose';
import Promo from '../components/Promo';

export default compose(
  withState('isExpanded', 'setIsExpanded', false),

  withHandlers({
    expandPromo: props => () => {
      props.setIsExpanded(true);
    },
  }),
)(Promo);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/Promo.js